var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 0.666504C6.63608 0.666504 0.666748 6.63584 0.666748 13.9998C0.666748 20.6838 5.59075 26.2038 12.0067 27.1678V17.5332H8.70808V14.0278H12.0067V11.6958C12.0067 7.8345 13.8881 6.13984 17.0974 6.13984C18.6347 6.13984 19.4467 6.25317 19.8321 6.30517V9.36384H17.6427C16.2801 9.36384 15.8041 10.6558 15.8041 12.1118V14.0278H19.7974L19.2561 17.5332H15.8054V27.1958C22.3134 26.3145 27.3334 20.7492 27.3334 13.9998C27.3334 6.63584 21.3641 0.666504 14.0001 0.666504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector (2).7638a5cbdc629dab0e7510fe29e314cd.svg";
export { ForwardRef as ReactComponent };